import { Component } from '@angular/core';
import { ColumnCheckboxDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-checkbox',
  templateUrl: './ap-column-checkbox.component.html',
})
export class ApColumnCheckboxComponent extends ApColumnBase<ColumnCheckboxDto> {

  isDisabled: boolean;
  isVisible: boolean;

  load() {
    if (this.columnInfoDto.IsDisabled) {
      this.isDisabled = this.columnInfoDto.IsDisabled(this.dataItem);
    } else {
      this.isDisabled = false;
    }
    if (this.columnInfoDto.IsChecked) {
      this.dataItem.Selected = this.columnInfoDto.IsChecked(this.dataItem);
    }
    if (this.columnInfoDto.IsVisible) {
      this.isVisible = this.columnInfoDto.IsVisible(this.dataItem);
    } else {
      this.isVisible = true;
    }
    return;
  }

  onChange() {
    this.columnInfoDto.OnChangeCallback(this.dataItem);
  }
}
